import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toast-check",
  "use": "toast-check-usage",
  "viewBox": "0 0 17.5 17.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.5 17.5\" id=\"toast-check\"><path d=\"M8.75,17.5A8.75,8.75,0,1,1,17.5,8.75,8.76,8.76,0,0,1,8.75,17.5ZM5.375,8.125l-1,.937L7.5,12.188l5.625-5.563-1-1L7.5,10.25,5.375,8.125Z\" transform=\"translate(0 0)\" fill=\"#f4fff7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol